import { NodeViewWrapper, NodeViewProps } from '@tiptap/react'
import { useState, useRef, useEffect } from 'react'
import { X, Code } from 'lucide-react'
import { Popover, PopoverTrigger, PopoverContent } from '@/components/ui/popover'

export default function VariableChipView({ node, updateAttributes, deleteNode }: NodeViewProps) {
  const [open, setOpen] = useState(false)
  const [fallbackValue, setFallbackValue] = useState(node.attrs.fallback || '')
  const inputRef = useRef<HTMLInputElement>(null)

  const { label, fallback } = node.attrs

  const handleSaveFallback = () => {
    updateAttributes({ fallback: fallbackValue || null })
    setOpen(false)
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      handleSaveFallback()
    } else if (e.key === 'Escape') {
      setOpen(false)
    }
  }

  useEffect(() => {
    if (open && inputRef.current) {
      inputRef.current.focus()
    }
  }, [open])

  useEffect(() => {
    setFallbackValue(node.attrs.fallback || '')
  }, [node.attrs.fallback])

  return (
    <NodeViewWrapper as="span" className="inline">
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <span
            className="inline-flex items-center gap-1 px-2 py-0.5 mx-0.5 bg-blue-100 text-blue-800 rounded-md text-sm cursor-pointer hover:bg-blue-200 transition-colors border border-blue-200"
            contentEditable={false}
          >
            <Code className="w-3 h-3" />
            <span className="font-medium">{label}</span>
            {fallback && <span className="text-blue-600 text-xs">| {fallback}</span>}
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation()
                deleteNode()
              }}
              className="ml-0.5 p-0.5 hover:bg-blue-300 rounded transition-colors"
            >
              <X className="w-3 h-3" />
            </button>
          </span>
        </PopoverTrigger>

        <PopoverContent className="w-80" align="start" sideOffset={8}>
          <div className="space-y-4">
            <div>
              <div className="flex items-center gap-2 text-sm text-gray-600 mb-1">
                <Code className="w-4 h-4" />
                <span>{label}</span>
              </div>
              <p className="text-xs text-gray-500">
                Este valor sera inserido aqui quando a mensagem for enviada
              </p>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Fallback</label>
              <input
                ref={inputRef}
                type="text"
                value={fallbackValue}
                onChange={(e) => setFallbackValue(e.target.value)}
                onKeyDown={handleKeyDown}
                placeholder="Texto quando o valor nao existe"
                className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
              />
              <p className="mt-1 text-xs text-gray-500">
                Este texto sera usado se a variavel estiver vazia
              </p>
            </div>

            <div className="flex justify-end gap-2">
              <button
                type="button"
                onClick={() => setOpen(false)}
                className="px-3 py-1.5 text-sm text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
              >
                Cancelar
              </button>
              <button
                type="button"
                onClick={handleSaveFallback}
                className="px-3 py-1.5 text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
              >
                Salvar
              </button>
            </div>
          </div>
        </PopoverContent>
      </Popover>
    </NodeViewWrapper>
  )
}
